import React, { useState, useEffect } from 'react';
import { RenderElement, RenderControl } from "components/RenderHelpers";
import {
  PRT_DETAIL_ACTIONS,
  getArmCohortData,
  getCohortsHistory,
  getProtocolDetails
} from "actions/protocols/protocoldetail";
import { getOpenSetup } from 'actions/protocols/opensetup';
// import { compose, withHandlers } from "recompose";
import * as selectors from "selectors";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { bindLogger } from "helpers/BindLogger";
import { withAppContext } from "@ctsu/loader";
import { openModal } from "actions/common";
import _ from 'lodash';
import CohortsArmGrid from "./CohortsArmManagement";
import ArmsGrid from "./Arms";

const lSelector = selectors.createLoadingSelector([
  PRT_DETAIL_ACTIONS.GET_COHORTS,
  PRT_DETAIL_ACTIONS.GET_ARM_COHORTS,
  PRT_DETAIL_ACTIONS.GET_STRATA
]);
const eSelector = selectors.createErrorMessageSelector([
  PRT_DETAIL_ACTIONS.GET_COHORTS,
  PRT_DETAIL_ACTIONS.GET_ARM_COHORTS,
  PRT_DETAIL_ACTIONS.GET_STRATA
]);


const CohortArmContainer = (props) => {
    const {
    isCohortsarmerror,
    protocolNumber,
    isCohortsarmloading,
    isStrataloading,
    isStrataerror,
    getArmCohort,
    onGetOpenSetupData,
    context,
    // loadCohortsHistory,
    loadStrataHistory,
    onOpenModal,
    CanUserAccessInfo,
    openSetupInfo,
    getCohHist
  } = props;


    const [highlightObj, sethighlightObj] = useState({ highlightRow: 0 });
    const [highlightArmObj, setHighlightArmObj] = useState({ highlightRow: 0 });
    const [cohort, setCohort] = useState({});
    const [selectedCohort, setSelectedCohort] = useState(null);
    // const [armData, setArmData] = useState([]);
  
    const cohortData = useSelector(state => state.prtDetails.cohortsArmData);

     useEffect(() => {
        if ((openSetupInfo && openSetupInfo.openConfig?.isCohortArmManagement)&& (!_.isEmpty(protocolNumber))) {
          bindLogger(getArmCohort, context)(protocolNumber)
        }
      }, [protocolNumber, getArmCohort, openSetupInfo])
      
      useEffect(() => {
        if (!_.isEmpty(protocolNumber)) {
        //   bindLogger(getCohort, context)(protocolNumber)
          bindLogger(onGetOpenSetupData, context)(protocolNumber);
        }
      }, [protocolNumber, getArmCohort, onGetOpenSetupData, context]);
    
    const onArmRowClick = (row, index) => {
        if (index > 0) {
        setHighlightArmObj({ highlightRow: index });
        }
    }
    const onArmdataload = res => {
        if (res.data.length > 0) {
        onArmRowClick(res.data[0], 0)
        }
    }
    const onRowClick = (row, index) => {
        if (index >= 0) {
        sethighlightObj({ highlightRow: index });
        setCohort(row);
        }
        if ((openSetupInfo && openSetupInfo.openConfig?.isCohortArmManagement) && (index >= 0)) {
        setHighlightArmObj({ highlightRow: index });
        // setArmData(row.armsList); // replace armsList with actual
        // setArmData(CohortsArmData[0].armsList);
        setSelectedCohort(row);
        }
    }
    const onLoad = (response) => {
        if (response.data.length > 0) {
        onRowClick(response.data[0], 0);
        }
    }

    const loadCohortsHistory = (evt, id) => {
      bindLogger(getCohHist, context)(id);
    }
    return(
        <RenderElement access={openSetupInfo && openSetupInfo.openConfig?.isCohortArmManagement}>
        <RenderControl
          isLoading={isCohortsarmloading}
          iserror={isCohortsarmerror}
          compName="Cohorts"
          title="Cohorts"
          permission={CanUserAccessInfo}
          >
            <CohortsArmGrid
              // data={CohortsArmData}
              cohortData={cohortData}
            //   loadStatusRecords={loadStatusRecords}
              highlightObj={highlightObj}
              rowClick={onRowClick}
              onLoad={onLoad}
              setHighlighted={sethighlightObj}
              loadHistory={loadCohortsHistory}
              onOpenModal={onOpenModal}
              // CanUserEditCohorts={checkStatus()}
            />
        </RenderControl>
        <RenderControl
            isLoading={isStrataloading}
            iserror={isStrataerror}
            title={`Arms for Cohort ${cohort.cohortName}`}
            compName="Arms"
            permission={CanUserAccessInfo}
          >
            <RenderElement access={cohortData?.length>0}>
              <ArmsGrid
                data={selectedCohort?.arms}
                selectedCohort={selectedCohort}
                setSelectedCohort={setSelectedCohort}
                // loadStatusRecords={loadStatusRecords}
                loadHistory={loadStrataHistory}
                highlightObj={highlightArmObj}
                setHighlighted={setHighlightArmObj}
                onLoad={onArmdataload}
                rowClick={onArmRowClick}
                onOpenModal={onOpenModal}
                // CanUserEditStrata={checkStatus()}
              />
            </RenderElement>
          </RenderControl>
      </RenderElement>
    )
};

const withConnectState = connect(
  (state, ownProps) => ({
    prtInfo: state.prtDetails.prtInfo,
    isCohortsarmloading: lSelector(state),
    isCohortsarmerror: eSelector(state),
    openSetupInfo: state.openData.openData
  }),
  (dispatch) =>
    bindActionCreators(
      {
        getArmCohort: getArmCohortData,
        onGetOpenSetupData: getOpenSetup,
        getCohHist: getCohortsHistory,
        onOpenModal: openModal,
        getPrtDetails: getProtocolDetails
      },
      dispatch
    )
);

// const CohortArmContainer = compose(
//     withConnectState,
//     withHandlers({
//     loadCohortsHistory: props => (evt, id) => {
//       const { context, getCohHist } = props;
//       bindLogger(getCohHist, context)(id);
//     }
//   })
// )(CohortArmContainerInfo);

export default withAppContext(withConnectState(CohortArmContainer));